export default __webpack_public_path__ + "static/media/HeroText.56b56760.png";